import E from 'wangeditor'; // npm 安装
import './index.less';
import api from '@/apis';
import { message } from '@drip/drip-design';

const { $, PanelMenu, Panel } = E;

class AlertMenu extends PanelMenu {
  constructor(editor) {
    // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
    const $elem = $(
      `<div class="w-e-menu" data-title="上传文件" >
              <img src='//img30.360buyimg.com/pop/jfs/t1/161845/13/6954/2408/602f776aE06880fe4/b6c932dadfdc26ce.png' />
            </div>`
    );
    super($elem, editor);
    this.editor = editor;
  }

  // 菜单点击事件
  clickHandler() {
    // 做任何你想做的事情
    // 可参考【常用 API】文档，来操作编辑器
    this.createPanel();
  }

  createPanel() {
    const panel = new Panel(this, this.createPanelConf());
    panel.create();
  }

  insertDom(url, fileName, fileType = '') {
    if (!fileName || !url) return;
    this.editor.cmd.do(
      'insertHTML',
      `<a href="${url}" target="_blank" rel="noreferrer" contentType="${fileType}">${fileName}</a>`
    );
  }

  uploadFile(files) {
    if (!files.length) {
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    api
      .jdCloudOssfileupload(formData)
      .then((res) => {
        const { ret, msg } = res;
        if (ret === '0' && res.data) {
          this.insertDom(res.data.urlList[0], res.data.fileNameList[0], files[0].type);
        } else {
          message.error(msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  }

  createPanelConf() {
    const upTriggerId = 'up-trigger-id';
    const upFileId = 'up-file-id';
    const tabsConf = [
      {
        // 标题
        title: '上传文件',
        // 模板
        tpl: `<div class="w-e-up-img-container">
                      <div id="${upTriggerId}" class="w-e-up-btn">
                          <i class="w-e-icon-upload2"></i>
                      </div>
                      <div style="display:none;">
                          <input id="${upFileId}" type="file" />
                      </div>
                  </div>`,
        // 事件绑定
        events: [
          // 触发选择图片
          {
            selector: '#' + upTriggerId,
            type: 'click',
            fn: () => {
              const $file = $('#' + upFileId);
              const fileElem = $file.elems[0];
              if (fileElem) {
                fileElem.click();
              } else {
                // 返回 true 可关闭 panel
                return true;
              }
            },
          },
          // 选择图片完毕
          {
            selector: '#' + upFileId,
            type: 'change',
            fn: () => {
              const $file = $('#' + upFileId);
              const fileElem = $file.elems[0];
              if (!fileElem) {
                // 返回 true 可关闭 panel
                return true;
              }

              // 获取选中的 file 对象列表
              const fileList = fileElem.files;
              if (fileList.length) {
                this.uploadFile(fileList);
              }

              // 返回 true 可关闭 panel
              return true;
            },
          },
        ],
      },
    ];
    // tabs end
    return {
      width: 300,
      height: 0,
      tabs: tabsConf,
    };
  }

  // 菜单是否被激活（如果不需要，这个函数可以空着）
  // 1. 激活是什么？光标放在一段加粗、下划线的文本时，菜单栏里的 B 和 U 被激活，如下图
  // 2. 什么时候执行这个函数？每次编辑器区域的选区变化（如鼠标操作、键盘操作等），都会触发各个菜单的 tryChangeActive 函数，重新计算菜单的激活状态
  tryChangeActive() {
    // 激活菜单
    // 1. 菜单 DOM 节点会增加一个 .w-e-active 的 css class
    // 2. this.this.isActive === true
    this.active();

    // // 取消激活菜单
    // // 1. 菜单 DOM 节点会删掉 .w-e-active
    // // 2. this.this.isActive === false
    // this.unActive()
  }
}

export default AlertMenu;
